/**
 * iOS Safari 在 input font-size < 16px 時會 auto-zoom，且 reload / 導頁後常會殘留縮放。
 * 透過暫時把 <meta name="viewport"> 的 maximum-scale 鎖成 1，強制 Safari 把縮放彈回 1.0，
 * 隨後還原成允許使用者手動雙指縮放的內容。
 *
 * 對 Android / 非 iOS 瀏覽器幾乎無副作用（scale 本來就 1）。
 */

const DEFAULT_VIEWPORT = 'width=device-width, initial-scale=1';
const LOCK_VIEWPORT = 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0';

function isIosLike() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  // iPhone / iPad（含 iPadOS 13+ 以 Mac UA 偽裝 + touch 能力）
  if (/iPad|iPhone|iPod/.test(ua)) return true;
  if (ua.includes('Mac') && typeof document !== 'undefined' && 'ontouchend' in document) return true;
  return false;
}

/**
 * 將視窗縮放強制還原為 1.0。約 500ms 後恢復可縮放狀態。
 * 重複呼叫安全。
 */
export function resetMobileZoom() {
  if (typeof document === 'undefined') return;
  if (!isIosLike()) return;

  const meta = document.querySelector('meta[name="viewport"]');
  if (!meta) return;

  const original = meta.getAttribute('content') || DEFAULT_VIEWPORT;
  // 若目前已經鎖住（重複呼叫），就不再疊一次
  if (original.includes('maximum-scale=1') && original.includes('user-scalable=0')) {
    return;
  }

  meta.setAttribute('content', LOCK_VIEWPORT);
  // 強制瀏覽器重新 layout；部分 iOS 版本需要一點時間才會套用
  window.setTimeout(() => {
    meta.setAttribute('content', original);
  }, 500);
}

export default resetMobileZoom;
